exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estimated-salary[data-v-5b7c98f2] {\n  width: 100%;\n  text-align: center;\n  background: #0075FF;\n  border-radius: 6px;\n  color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 25px;\n}\n.estimated-salary small[data-v-5b7c98f2] {\n  font-size: 18px;\n  font-weight: 400;\n}", ""]);

// exports
